/* Core */
(function ($, angular) {
    if (typeof ($) !== "function" && angular != null) {
        $ = window.jQuery = window.$ = angular.element;
        angular.module('xhr', [], ['$xhrFactoryProvider', config]);
        window.$$injector = angular.injector(['ng', 'xhr'], true);
    }

    function config($xhrFactoryProvider) {
        var cache = [];
        $xhrFactoryProvider.$get = function () {
            return function (method, url, createForUseAfterTick) {
                return !createForUseAfterTick ? cache.shift() || new window.XMLHttpRequest()
                    : cache[cache.push(new window.XMLHttpRequest()) - 1];
            }
        }
    }
})(window.jQuery, window.angular);

/* Events */
(function ($, angular, $injector) {
    if (!$injector) return;

    var jQueryProto = $.prototype, originalBind = jQueryProto.on;

    jQueryProto.bind = bind;
    jQueryProto.load = load;
    jQueryProto.on = bind;

    function bind(type, fn, unsupported) {
        angular.forEach(this, function (element) {
            if (angular.isUndefined(element.addEventListener)) {
                element.addEventListener = angular.noop;
                element.removeEventListener = angular.noop;
            }
        });
        return originalBind.apply(this, arguments);
    }
    function load(func) {
        return this.on('load', func);
    }
})(window.jQuery, window.angular, window.$$injector);

/* Ajax */
(function ($, angular, $injector) {
    if (!$injector) return;

    $.ajax = ajax;

    ////////////////////////////

    function ajax(settings) {
        var
            $http = $injector.get('$http'),
            $xhrFactory = $injector.get('$xhrFactory'),
            xhr = $xhrFactory(settings.type, settings.url, true);

        if ((settings.contentType || '').indexOf("application/x-www-form-urlencoded") != -1) 
            settings.data = $.param(settings.data);

        $http({
            headers: { 'Content-Type': settings.contentType },
            url: settings.url,
            method: settings.type,
            data: settings.data,
            timeout: settings.timeout
        })
		.then(success, error);

        return xhr;

        function success(response) {
            if (settings.success)
                settings.success(response.data, 'success', xhr);
        }
        function error(response) {
            if (settings.error)
                settings.error(xhr, 'error', response.statusText);
        }

    }

})(window.jQuery, window.angular, window.$$injector);

/* Promise */
(function ($, angular, $injector) {
    if (!$injector) return;

    // Interface
    Promise.prototype.then = then;
    Promise.prototype.done = done;
    Promise.prototype.fail = fail;
    window.$$Promise = Promise;

    // Implementation
    var toString = Object.prototype.toString;

    function Promise(promise) {
        this._promise = promise;
    }
    function then(doneCallback, failCallback, progressCallback) {
        return addHandlers(this, doneCallback, failCallback, progressCallback);
    }
    function done(doneCallback) {
        addHandlers(this, doneCallback, null, null);
        return this;
    }
    function fail(failCallback) {
        addHandlers(this, null, failCallback, null);
        return this;
    }

    // Helpers
    function addHandlers(promise, doneCallback, failCallback, progressCallback) {
        var _promise = promise._promise, state = _promise.$$state, pending, result;

        result = _promise.then(doneCallback, failCallback, progressCallback);
        pending = state.pending[state.pending.length - 1];
        for (var i = 1; i <= 3; i++)
            if (pending[i]) pending[i] = wrapCallback(promise, pending[i], pending[0], i);

        return new Promise(result);
    }
    function wrapCallback(promise, method, deferred, type) {
        var _promise = promise._promise, state = _promise.$$state, context, args;

        return function () {
            context = state.context && (deferred.promise.$$state.context = state.context) || promise;
            args = arguments.length == 1 && toString.apply(arguments[0]) == '[object Arguments]' ? arguments[0] : arguments;
            return fix(method.apply(context, args), deferred, type);
        }
    }
    function fix(result, deferred, type) {
        if (result instanceof Promise) {
            var fns = callOnce(deferred, deferred.$$resolve, deferred.$$reject);
            result.then = function (done, error, notify) {
                return Promise.prototype.then.call(this, fns[0], fns[1], notify);
            }
        }
        else if (type == 2 && !angular.isUndefined(result)) {
            deferred = $.Deferred();
            deferred.reject(result);
            result = deferred.promise();
        }

        return result;
    }

    // Copied from angular
    function callOnce(self, resolveFn, rejectFn) {
        var called = false;
        function wrap(fn) {
            return function (value) {
                if (called) return;
                called = true;
                fn.call(self, arguments);
            };
        }
        return [wrap(resolveFn), wrap(rejectFn)];
    }
})(window.jQuery, window.angular, window.$$injector);

/* Deferred */
(function ($, angular, $injector) {
    if (!$injector) return;

    // Interface
    $.Deferred = createDeferred;
    Deferred.prototype.resolve = resolve;
    Deferred.prototype.resolveWith = resolveWith;
    Deferred.prototype.reject = reject;
    Deferred.prototype.rejectWith = rejectWith;
    Deferred.prototype.promise = promise;

    // Implementation
    var Promise = window.$$Promise;

    function createDeferred() {
        var $q = $injector.get('$q');
        return new Deferred($q.defer());
    }
    function Deferred(deferred) {
        this._deferred = deferred;
    }
    function resolve(args) {
        this._deferred.resolve(arguments);
    }
    function resolveWith(context, args) {
        this._deferred.promise.$$state.context = context;
        resolve.apply(this, args);
    }
    function reject(args) {
        this._deferred.reject(arguments);
    }
    function rejectWith(context, args) {
        this._deferred.promise.$$state.context = context;
        reject.apply(this, args);
    }
    function promise() {
        return new Promise(this._deferred.promise);
    }
})(window.jQuery, window.angular, window.$$injector);

/* Utilities */
(function ($, angular, $injector) {
    if (!$injector) return;

    $.each = each;
    $.extend = extend;
    $.inArray = inArray;
    $.isArray = angular.isArray; // *
    $.isEmptyObject = isEmptyObject; // copied from jQuery
    $.isFunction = angular.isFunction; // *
    $.makeArray = makeArray;
    $.merge = merge; // copied from jQuery
    $.noop = angular.noop; // *
    $.param = param;
    $.trim = trim;
    $.type = type;
    $.support = { cors: true };

    ////////////////////////////

    function each(obj, callback) {
        angular.forEach(obj, function (value, key) {
            callback.call(value, key, value);
        });
    }
    function extend() {
        if (typeof arguments[0] === "boolean") {
            var args = Array.prototype.slice.call(arguments, 1);
            return angular.merge.apply(null, args);
        }
        return angular.extend.apply(null, arguments)
    }
    function inArray(value, array) {
        return array.indexOf(value);
    }
    function isEmptyObject(obj) {
        var name;
        for (name in obj)
            return false;
        return true;
    }
    function makeArray(obj) {
        var result = [];
        angular.forEach(obj, function (value) {
            result.push(value);
        });
        return result;
    }
    function merge(first, second) {
        var l = second.length,
			i = first.length,
			j = 0;

        if (typeof l === "number") {
            for (; j < l; j++) {
                first[i++] = second[j];
            }
        } else {
            while (second[j] !== undefined) {
                first[i++] = second[j++];
            }
        }

        first.length = i;

        return first;
    }
    function param(a) {
        var $httpParamSerializerJQLike = $injector.get('$httpParamSerializerJQLike');
        return $httpParamSerializerJQLike(a);
    }
    function type(obj) {
        return obj == null ? obj + "" : typeof obj;
    }
    function trim(text) {
        return text == null ? "" : text.trim();
    }
})(window.jQuery, window.angular, window.$$injector);

/* Scrolling */
(function ($, angular, $injector) {
    if (!$injector) return;
    var jQueryProto = $.prototype;

    jQueryProto.scrollParent = scrollParent;
    jQueryProto.clientRect = clientRect;
    jQueryProto.scrollTop = scrollTop;
    jQueryProto.scrollHeight = scrollHeight;

    function scrollParent(includeHidden) {
        var
            element = this[0],
            doc = element.ownerDocument || document,
            position,
            excludeStaticParent,
            overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
            scrollParent,

            parent = this,
            computed,
            isExcluded;

        if (element) {
            position = getComputedStyle(element).position;
            excludeStaticParent = position === "absolute";

            while ((parent = parent.parent()) && parent.length && parent.prop('nodeType') !== 9 && !scrollParent) {
                computed = getComputedStyle(parent[0]);
                isExcluded = excludeStaticParent && computed.position === "static";
                if (!isExcluded && overflowRegex.test(computed.overflow + computed.overflowY + computed.overflowX))
                    scrollParent = parent;
            }

            scrollParent = position === "fixed" || !scrollParent ? $(doc): scrollParent;

            // If it is document, html, or body return window to fix cross browser issues
            if (scrollParent[0] === doc || scrollParent[0] === doc.body || scrollParent[0] === doc.documentElement)
                scrollParent = $(doc.defaultView);

            return scrollParent;
        }
        return $();
    };
    function clientRect() {
        var element = this[0], width, height, win;
        if (element) {
            win = getWindow(element);
            if (win) {
                width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
                height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
                return { top: 0, right: width, bottom: height, left: 0, width: width, height: height };
            }
            else
                return element.getBoundingClientRect();
        }
    }
    function scrollTop(value) {
        var element = this[0], win;
        if (element) {
            win = getWindow(element);

            if (value === undefined)
                return win ? win.pageYOffset : element.scrollTop;

            if (win)
                win.scrollTo(win.pageXOffset, value);
            else
                element.scrollTop = value;
        }
    }
    function scrollHeight() {
        var element = this[0], body, html, win;
        if (element) {
            win = getWindow(element);
            if (win){
                body = win.document.body;
                html = win.document.documentElement;
                return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            }
            else
                return element.scrollHeight;
        }
    }

    function getWindow(elem) {
        return elem === elem.window ? elem : elem.nodeType === 9 && elem.defaultView;
    }

})(window.jQuery, window.angular, window.$$injector);

/* Clean Up */
(function () {
    delete window.$$injector;
    delete window.$$Promise;
})();
